// extracted by mini-css-extract-plugin
export default {"disclaimer":"vYZ7qK","radioButton":"sSzw_z","checked":"t1jz3k"};